import React from "react";

import useBrandDetails from "@v1/components/editor/ai/useBrandDetails";
import { setLeftBarActiveTab } from "@v1/reducers/ui-reducer";
import { useEditorDispatch } from "@v1/store/store";
import { Pencil } from "lucide-react";

import { useBrandDetailsTabs } from "../designLibrary/BrandDetailsContext";

interface BrandContextPreviewProps {}

export const BrandContextPreview: React.FC<BrandContextPreviewProps> = () => {
  const { brandDetails } = useBrandDetails();
  const { setSelectedTab } = useBrandDetailsTabs();
  const dispatch = useEditorDispatch();

  // Check if there are any brand details to display
  const hasBrandDetails =
    brandDetails &&
    (brandDetails.brandName ||
      brandDetails.brandVoice ||
      brandDetails.whatBusinessSells ||
      brandDetails.whoIsCustomer);

  return (
    <button
      className="border-0.5 border-border group relative flex w-[200px] items-center gap-1 rounded-md px-2 py-1"
      onClick={() => {
        dispatch(setLeftBarActiveTab("shopStyles"));
        setSelectedTab("context");
      }}
    >
      <div className="line-clamp-2 w-full overflow-hidden text-ellipsis text-left text-xs">
        {hasBrandDetails ? (
          <>
            {brandDetails?.brandName} {brandDetails?.brandVoice}{" "}
            {brandDetails?.whatBusinessSells} {brandDetails?.whoIsCustomer}
          </>
        ) : (
          <span className="text-placeholder">Add your brand context!</span>
        )}
      </div>
      <div className="bg-surface absolute inset-0 z-50 flex items-center justify-center rounded-md opacity-0 transition-opacity group-hover:opacity-100">
        <Pencil className="text-muted h-5 w-5" />
      </div>
    </button>
  );
};
